import * as moment from "moment-timezone";

export const DATE_TIME_FORMAT = 'YYYY-MM-DD, HH:mm';

export const getLocalDate = (date: string, format: string) => {
  if (date && format) {
    return moment.utc(date).tz('Europe/Warsaw').format(format);
  }

  return '';
}
